import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { autorun, makeAutoObservable, runInAction } from 'mobx';
import { getProducerListByAgency } from 'api/operations/userService';
import { getRootStoreInstance, RootStore } from 'store/rootStore';
import { Producer } from 'types/userService';

export interface SelectProducerFormFields extends DefaultFormFields {
  producer: FormControl<string[]>;
  producerNotFound: FormControl<boolean>;
}

export class SelectProducerDelegate {
  private _rootStore: RootStore = getRootStoreInstance();
  private _availableProducers: Producer[] = [];

  public get availableProducers(): Producer[] {
    return this._availableProducers;
  }

  public get producerNotFound(): boolean {
    return this.form.fields.producerNotFound.value;
  }

  public get isFormValid(): boolean {
    return !!this.form.fields.producer.value || this.form.fields.producerNotFound.value;
  }

  public get selectedProducer(): Producer | undefined {
    return this.availableProducers.find((producer) => producer.id === this.form.fields.producer.value[0]);
  }

  public form = new FormController<SelectProducerFormFields>({
    producer: new FormControl<string[]>([], { optional: true }),
    producerNotFound: new FormControl<boolean>(false, { optional: true }),
  });

  public async requestAvailableProducers(): Promise<void> {
    this.form.setLoading(true);
    const agencyId = this._rootStore.userStore.coreUserInfo.agencyId;
    await getProducerListByAgency(agencyId, '').then((producers) => {
      runInAction(() => {
        this._availableProducers = producers;
        if (producers.length === 0) {
          this.form.populateFields({ producerNotFound: true });
        }
        this.form.setLoading(false);
      });
    });
  }

  public populateProducer(producerId?: string): void {
    this.form.populateFields({
      producer: producerId ? [producerId] : [],
    });
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    autorun(() => {
      if (this.form.fields.producerNotFound.value) {
        this.form.fields.producer.overrideValue([]);
      }
    });

    autorun(() => {
      if (this.form.fields.producer.value.length > 0) {
        this.form.fields.producerNotFound.overrideValue(false);
      }
    });
  }
}
